define([
	"dojo/_base/declare",
	"dojo/window",
	"csi/action/MoveUpDownController"
], function(declare,window,MoveUpDownController) {

	return declare(MoveUpDownController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		preProcess: function() {
			// summary: move source block element to destination
			this.inherited(arguments);

			if (this.targetNode) {
				var	view = this.widget;
				var	e = this.refNode;
				var	sp = this.refNode.parentNode;
				var	dp = this.targetNode.parentNode;
				var	eNext = view.getRefNodeNext(this.refNode);
				var	eDest = this.m_bUp ? this.targetNode : view.getRefNodeNext(this.targetNode);
				var	eTemp;

				// update store
				var	qr = view.getQueryResultByDomNode(e);
				var	qrNext = view.getQueryResultByDomNode(eDest);
				qr.moveInStore(qrNext);
				
				// update view
				while (e != eNext) {
					eTemp = e.nextSibling;
					sp.removeChild(e);
					dp.insertBefore(e, eDest);
					e = eTemp;
				}

				eNext = this.m_bUp ? view.getRefNodeNext(this.refNode, true, true) : eDest;
				view.scrollIntoView(eNext || this.refNode);
			}
		}
	});
});